import { render } from "./FaseProd.vue?vue&type=template&id=367bee4c&scoped=true"
import script from "./FaseProd.vue?vue&type=script&lang=js"
export * from "./FaseProd.vue?vue&type=script&lang=js"

import "./FaseProd.vue?vue&type=style&index=0&id=367bee4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367bee4c"]])

export default __exports__